export default __webpack_public_path__ + "static/media/google-pay.22a233b4.png";